import { useQuery } from '@tanstack/react-query'
import { marketingApi, LocationHeatmapParams } from '@api/endpoints/marketing'

export const marketingKeys = {
  all: ['marketing'] as const,
  heatmap: (params: LocationHeatmapParams) => [...marketingKeys.all, 'heatmap', params] as const,
}

/**
 * Fetch the anonymised location-activity heatmap for a period.
 * Disabled until a valid from < to range is supplied.
 */
export function useLocationHeatmap(params: LocationHeatmapParams) {
  const enabled = Boolean(params.from && params.to && params.from < params.to)
  return useQuery({
    queryKey: marketingKeys.heatmap(params),
    queryFn: () => marketingApi.getLocationHeatmap(params),
    enabled,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
  })
}
